var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet, KeyValue, MessageBanner, TextLink, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { DeclarationStatusDto, } from "../../types/Api";
import { FieldRow } from "../../components/FieldRow";
import { AccordionSection } from "../../components/AccordionSection";
import { ExpandCollapseToggle } from "../../components/ExpandCollapseToggle";
import { getStatusTranslation } from "../../utils/getStatusTranslation";
import { usePermissions } from "../../hooks/usePermissions";
var PublisherPrefixDetail = function (_a) {
    var _b;
    var publisherPrefix = _a.publisherPrefix;
    var intl = useIntl();
    var history = useHistory();
    // The numbering state and the last-used-number declaration are agency-internal:
    // the backend does not return them to the public-only view (DB-837).
    var hasPublicOnlyView = usePermissions().hasPublicOnlyView;
    var _c = useState({
        general: true,
    }), accordionStatus = _c[0], setAccordionStatus = _c[1];
    var _d = useState(true), expandAll = _d[0], setExpandAll = _d[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                general: false,
            });
        }
        else {
            setAccordionStatus({
                general: true,
            });
        }
        setExpandAll(!expandAll);
    };
    var renderPublisherLink = function (publisher) {
        if (!(publisher === null || publisher === void 0 ? void 0 : publisher.sourceId) || !(publisher === null || publisher === void 0 ? void 0 : publisher.name))
            return (publisher === null || publisher === void 0 ? void 0 : publisher.name) || "";
        return (React.createElement(TextLink, { onClick: function () {
                return history.push("/bragency/publishers/detail?sourceId=".concat(publisher.sourceId));
            } }, publisher.name));
    };
    var renderPublisherPrefixRangeLink = function (range) {
        if (!(range === null || range === void 0 ? void 0 : range.id))
            return "—";
        var rangeLabel = "".concat(range.start, "\u2013").concat(range.end);
        return (React.createElement(TextLink, { onClick: function () {
                return history.push("/bragency/publisher-prefix-ranges?detail=".concat(range.id));
            } }, rangeLabel));
    };
    var renderAgencyPrefixLink = function (agencyPrefix) {
        var _a, _b, _c, _d, _e;
        if (!(agencyPrefix === null || agencyPrefix === void 0 ? void 0 : agencyPrefix.id))
            return "—";
        var label = "".concat((_b = (_a = agencyPrefix.internationalPrefix) === null || _a === void 0 ? void 0 : _a.agency) !== null && _b !== void 0 ? _b : "", " ").concat((_d = (_c = agencyPrefix.internationalPrefix) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "", "-").concat((_e = agencyPrefix.value) !== null && _e !== void 0 ? _e : "");
        return (React.createElement(TextLink, { onClick: function () {
                return history.push("/bragency/agency-prefixes?detail=".concat(agencyPrefix.id));
            } }, label));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.detail.pane.title" })),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        !hasPublicOnlyView &&
            publisherPrefix.declarationStatus === DeclarationStatusDto.PENDING && (React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.declare.pending.banner" }))),
        React.createElement(AccordionSet, null,
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-agency.publisher-prefix.accordions.label.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.agencyPrefix.field.label" }), value: renderAgencyPrefixLink((_b = publisherPrefix.publisherPrefixRange) === null || _b === void 0 ? void 0 : _b.agencyPrefix) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.publisherPrefixRange.field.label" }), value: renderPublisherPrefixRangeLink(publisherPrefix.publisherPrefixRange) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.collections.general.publisher.selection.label" }), value: renderPublisherLink(publisherPrefix.publisher) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher-prefix.value.field.label", value: publisherPrefix.value }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher-prefix.status.field.label", value: getStatusTranslation(intl, publisherPrefix.status) }))),
                !hasPublicOnlyView && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher-prefix.nextSequence.field.label", value: publisherPrefix.nextSequence })))),
                !hasPublicOnlyView && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher-prefix.declarationStatus.field.label", value: publisherPrefix.declarationStatus
                                ? intl.formatMessage({
                                    id: "ui-br-agency.publisher-prefix.declarationStatus.".concat(publisherPrefix.declarationStatus),
                                })
                                : "" })))),
                !hasPublicOnlyView && publisherPrefix.lastUsedNumber && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.publisher-prefix.lastUsedNumber.field.label", value: publisherPrefix.lastUsedNumber }))))))));
};
export default PublisherPrefixDetail;
